import { Component, Input, type OnInit } from '@angular/core'
import { BdcCreatePropertyContactDialogService } from '../../bdc-create-property-contact-dialog/bdc-create-property-contact-dialog.service'
import { BdcContentV2Service, BdcContact, BdcContactProfileType } from '@tokeet-frontend/channel-content'
import { finalize, switchMap } from 'rxjs/operators'
import { ActionFailed, ConfirmDialogService, Toaster } from '@tokeet-frontend/tv3-platform'
import { Store } from '@ngrx/store'

@Component({
  selector: 'app-bdc-property-contacts',
  templateUrl: './bdc-property-contacts.component.html',
  styleUrls: ['./bdc-property-contacts.component.scss'],
})
export class BdcPropertyContactsComponent implements OnInit {
  @Input() propertyId: number

  contacts: BdcContact[] = []

  isLoading = true
  constructor(
    private store: Store<any>,
    private toaster: Toaster,
    private confirm: ConfirmDialogService,
    private contentService: BdcContentV2Service,
    private contactDialog: BdcCreatePropertyContactDialogService
  ) {}

  ngOnInit(): void {
    this.contentService
      .getPropertyContacts(this.propertyId)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        (data) => {
          this.contacts = data?.contacts || []
        },
        (error) => {
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }

  isGeneralMissing(ignoreContact?: BdcContact) {
    return !this.contacts.find(
      (contact) =>
        contact != ignoreContact &&
        contact.contact_profiles?.find((profile) => profile.type === BdcContactProfileType.GENERAL)
    )
  }

  onAdd() {
    this.contactDialog
      .open({
        contact: null,
        propertyId: this.propertyId,
        otherContacts: this.contacts,
        isGeneralMissing: this.isGeneralMissing(),
      })
      .subscribe((contacts) => {
        this.contacts = contacts
        this.toaster.success($localize`Contact added successfully`)
      })
  }

  onEdit(contact: BdcContact, index: number) {
    this.contactDialog
      .open({
        contact,
        contactIndex: index,
        propertyId: this.propertyId,
        otherContacts: this.contacts.filter((c, i) => i !== index),
        isGeneralMissing: this.isGeneralMissing(contact),
      })
      .subscribe((contacts) => {
        this.contacts = contacts
      })
  }

  onDelete(contact: BdcContact, index: number) {
    if (contact.contact_profiles.find((p) => p.type === BdcContactProfileType.GENERAL)) {
      this.toaster.error($localize`General Contact cannot be deleted`)
      return
    }
    this.confirm
      .confirm({
        title: $localize`Delete contact`,
        body: $localize`Are you sure you want to delete this contact?`,
      })
      .pipe(
        switchMap(() =>
          this.contentService.updatePropertyContacts(this.propertyId, {
            contacts: this.contacts.filter((c, i) => i !== index),
          })
        )
      )
      .subscribe(
        (data) => {
          this.contacts = data.contacts
          this.toaster.success($localize`Contact deleted successfully`)
        },
        (error) => {
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }
}
